import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 32,
		height: 32,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function SolutionsIcon(props) {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path opacity="0.5" d="M12 8V7C12 4.79086 13.7909 3 16 3V3C18.2091 3 20 4.79086 20 7V8" stroke={props.fill} strokeWidth="2" />
			<path fillRule="evenodd" clipRule="evenodd" d="M8 7C5.79086 7 4 8.79086 4 11V24C4 26.2091 5.79086 28 8 28H24C26.2091 28 28 26.2091 28 24V11C28 8.79086 26.2091 7 24 7H8ZM13 16C13 15.4477 13.4477 15 14 15H18C18.5523 15 19 15.4477 19 16C19 16.5523 18.5523 17 18 17H14C13.4477 17 13 16.5523 13 16ZM13 20C13 19.4477 13.4477 19 14 19H16C16.5523 19 17 19.4477 17 20C17 20.5523 16.5523 21 16 21H14C13.4477 21 13 20.5523 13 20Z" fill={props.fill} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<SolutionsIcon fill={props.fill} />
		</div>
	);
}